const STRINGS = {
  findButtonLabel: "Go",
  resetButtonLabel: "Reset",
  placeholder: "Find by...",
  noMatchFound: "No results. Change your criteria and try again.",
  findByLabel: "Find items",
  findButtonAriaLabel: "Go search data",
  resetButtonAriaLabel: "Reset results and clear",
  resetAnnouncement: "Results and search settings have been reset"
};
export default STRINGS;